import { maquinariaSections } from './maquinariaSections';

export const maquinariaManual = {
  id: 'mod-maquinaria',
  title: 'Maquinarias',
  isVisible: (ctx) => ctx.canSeeMachinery,
  intro:
    'Control de máquinas, vehículos, conductores, bitácora de eventos, mantenimiento y reportes. Cada ítem del menú Maquinarias tiene documentación completa (12 apartados).',
  sections: maquinariaSections,
};
